import { getEnvBaseUrl } from '../../../shared/common/helpers';
import { Axios } from '../../../shared/common/http';
import { CqmPatientMeasureTraceDto } from './traceability-models';

// Hand-rolled call (imports-slice.ts pattern) because the endpoint's generated client isn't
// published yet and local NSwag regen is version-skewed.
// TODO swap to generated CqmTraceabilityClient at next client bump.

export interface ApiEnvelope<T> {
    succeeded: boolean;
    message?: string;
    entity?: T;
}

// Absolute URL — the request interceptor calls `new URL(config.url)`, which throws on relative paths.
const traceUrl = (path: string) => `${getEnvBaseUrl()}/api/CqmTraceability${path}`;

export const fetchTrace = async (patientId: number, measureCmsId: string, year: number): Promise<ApiEnvelope<CqmPatientMeasureTraceDto>> => {
    const response = await Axios.get<ApiEnvelope<CqmPatientMeasureTraceDto>>(traceUrl(`/GetTrace/${patientId}/${encodeURIComponent(measureCmsId)}/${year}`));
    return response.data;
};
